
<div class="c-header__user-menu">
  <div class="o-grid -vertical-gutter -xs-gutter-large -md-gutter-medium l-user-menu-wrapper">
    <template v-if="user.isOnVacation">
      <div class="o-grid__item -xs-24">
        <StoreVacationInfo />
      </div>
    </template>

    <template v-else>
      <div class="l-user-menu__profile o-grid__item -xs-24">
        <div class="o-grid -xs-gutter-medium -xs-middle">
          <div class="o-grid__item -xs-shrink t-md-hide">
            <img
              class="l-user-menu__profile-avatar o-avatar -rounded -small js-header-avatar-preview"
              :src="user.avatarUrl"
              alt=""
            >
          </div>

          <div class="o-grid__item -xs-shrink">
            <div class="l-user-menu__profile-greeting o-text -xs-spaced -xs-semibold -xs-extra-dark -xs-lowercase">
              {{ randomGreeting }}
            </div>

            <div class="l-user-menu__profile-member-since o-text -xs-long-primer -xs-medium -xs-neutral-800 -xs-lowercase">
              {{ user.memberSinceText }}
            </div>
          </div>
        </div>
      </div>

      <div class="o-grid__item -xs-24">
        <div class="o-grid -vertical-gutter -xs-gutter-small">
          <div class="o-grid__item -xs-24">
            <a
              :href="user.profilePath"
              class="o-button -xs-large -xs-secondary -xs-flat t-fill"
              data-testid="button-menu-store"
              @click="registerInteraction('store')"
            >
              minha loja
            </a>
          </div>

          <div class="o-grid__item -xs-24 t-md-hide">
            <a
              href="/quero-vender"
              class="o-button -xs-large -xs-primary -xs-flat t-fill"
              data-testid="button-menu-sell"
              @click="registerInteraction('sell')"
            >
              quero vender
            </a>
          </div>
        </div>
      </div>
    </template>

    <div class="o-grid__item -xs-24">
      <div class="o-grid -vertical-gutter -xs-gutter-large -md-gutter-medium">
        <div
          v-if="isMyEnjoeiEnabled"
          class="o-grid__item -xs-24"
        >
          <a
            href="/meu-enjoei"
            class="c-header__user-menu-link"
            data-testid="button-menu-my-enjoei"
            @click="onClickMyEnjoei"
          >
            <Icon
              name="heart-happy-face"
              spaced="right"
              :size="{ xs: 'medium', md: 'small' }"
            />

            meu enjoei
          </a>
        </div>

        <div
          v-if="isMyEnjoeiEnabled"
          class="o-grid__item -xs-24"
        >
          <a
            href="/meu-enjoei/continue-comprando"
            class="c-header__user-menu-link"
            data-testid="button-menu-pending-carts"
            @click="onFavoritesLinkClick"
          >
            <Icon
              name="bag"
              spaced="right"
              :size="{ xs: 'medium', md: 'small' }"
            />

            continue comprando

            <span
              v-if="isMobile && user.pendingCartsCount > 0"
              class="o-count"
            >
              {{ user.pendingCartsCount }}
            </span>
          </a>
        </div>

        <div class="o-grid__item -xs-24 t-lg-hide">
          <a
            href="/perfil/mensagens"
            class="c-header__user-menu-link"
            data-testid="button-menu-inbox"
            @click="registerInteraction('inbox')"
          >
            <Icon
              name="inbox"
              spaced="right"
              :size="{ xs: 'medium', md: 'small' }"
            />

            mensagens

            <InboxNotification show-count />
          </a>
        </div>

        <div
          v-if="isMegaphoneEnabled"
          class="o-grid__item -xs-24"
        >
          <a
            :href="user.profilePath"
            class="c-header__user-menu-link"
            data-testid="button-menu-megaphone"
            @click="registerInteraction('megaphone')"
          >
            <Icon
              name="megaphone"
              spaced="right"
              :size="{ xs: 'medium', md: 'small' }"
            />

            megafone
          </a>
        </div>


        <div class="o-grid__item -xs-24">
          <a
            href="/central-de-vendas"
            class="c-header__user-menu-link"
            data-testid="button-menu-user-sales"
            @click="registerInteraction('sales')"
          >
            <Icon
              name="store"
              spaced="right"
              :size="{ xs: 'medium', md: 'small' }"
            />

            minhas vendas

            <span
              v-if="user.soldNotificationsCount > 0"
              class="o-count"
            >
              {{ user.soldNotificationsCount }}
            </span>
          </a>
        </div>

        <div class="o-grid__item -xs-24">
          <a
            href="/perfil/compras"
            class="c-header__user-menu-link"
            data-testid="button-menu-user-purchases"
            @click="registerInteraction('purchases')"
          >
            <Icon
              name="cart"
              spaced="right"
              :size="{ xs: 'medium', md: 'small' }"
            />

            minhas compras
          </a>
        </div>

        <div class="o-grid__item -xs-24">
          <a
            href="/enjubank"
            class="c-header__user-menu-link"
            data-testid="button-menu-enjubank"
            @click="registerInteraction('enjubank')"
          >
            <Icon
              name="cash"
              spaced="right"
              :size="{ xs: 'medium', md: 'small' }"
            />

            enjubank
          </a>
        </div>

        <div class="o-grid__item -xs-24">
          <a
            :href="user.likedProfilePath"
            class="c-header__user-menu-link"
            data-testid="button-menu-liked-products"
            @click="registerInteraction('liked_products')"
          >
            <Icon
              name="yeah-yeah"
              spaced="right"
              :size="{ xs: 'medium', md: 'small' }"
            />

            yeyezados
          </a>
        </div>

        <div class="o-grid__item -xs-24">
          <a
            href="/perfil/alterar"
            class="c-header__user-menu-link"
            data-testid="button-menu-settings"
            @click="registerInteraction('settings')"
          >
            <Icon
              name="cog"
              spaced="right"
              :size="{ xs: 'medium', md: 'small' }"
            />

            configurações
          </a>
        </div>

        <div class="o-grid__item -xs-24">
          <a
            href="/ajuda"
            class="c-header__user-menu-link"
            data-testid="button-menu-help"
            @click="registerInteraction('help')"
          >
            <Icon
              name="help"
              spaced="right"
              :size="{ xs: 'medium', md: 'small' }"
            />

            ajuda
          </a>
        </div>

        <div class="o-grid__item -xs-24">
          <form
            action="/usuario/sair"
            method="post"
            @submit.prevent="handleLogout"
          >
            <input
              name="_method"
              type="hidden"
              value="delete"
            >

            <input
              name="authenticity_token"
              type="hidden"
              :value="authenticityToken"
            >

            <button
              class="c-header__user-menu-link"
              data-testid="button-menu-logout"
              type="submit"
            >
              <Icon
                name="logout"
                spaced="right"
                :size="{ xs: 'medium', md: 'small' }"
              />

              sair
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
